<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Tutti i corsi regionali GESFOR sono disponibili in modalità FAD ottimizzati anche per tablet e smartphone. Potrai ottenere una Qualifica Professionale Riconosciuta stando comodamente a casa, in ufficio o dovunque ci sia un collegamento Internet.
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/gesforformazione.it/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/gesfor_formazione/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.gesforsrl.com/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.gesforsrl.com/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via Cesasre Augusto, 25<br>80078 Pozzuoli (NA) - Italia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390815264711">Telefono: (+39) 081-5264711</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:corsi@gesforsrl.it">corsi@gesforsrl.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+557854578964">Lunedì-Venerdì: 09:00 ÷ 20:00<br>Sabato: 08:30 ÷ 13:30</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2023 GESFOR - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2">
                    <ul>
                        <li><a target="_blank" href="https://www.gesforsrl.it/formazione/dichiarazione-sulla-privacy-ue/">Privacy Policy</a></li>
                        <li><a target="_blank" href="https://www.gesforsrl.it/formazione/cookie-policy-ue/">Cookie</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
